import { FC } from 'react';
import { Typography } from '@crisellevaldez/speculo-ui';

/**
 * The lead's name, then a detail line (their phone) — the header the call, SMS
 * and email thread views share. The name opens the contact when it can.
 */
export const ContactHeader: FC<{
  name: string | null;
  subtitle?: string | null;
  contactId?: string | null;
  onContactClick?: (contactId: string) => void;
  /** Shown when there is no name. */
  fallback: string;
}> = ({ name, subtitle, contactId, onContactClick, fallback }) => (
  <div className="flex flex-col min-w-0">
    {name && contactId && onContactClick ? (
      <button
        type="button"
        onClick={() => onContactClick(contactId)}
        className="self-start text-left"
        title={`Open ${name}`}
      >
        <Typography
          variant="h3"
          className="text-primaryfortext underline hover:text-primaryfortext/80"
        >
          {name}
        </Typography>
      </button>
    ) : (
      <Typography variant="h3" className="truncate">
        {name ?? fallback}
      </Typography>
    )}
    {/* font-normal: Modal.Header makes its contents semibold, which would bold this line. */}
    {subtitle && (
      <span className="text-xs font-normal text-muted-foreground mt-0.5 truncate">{subtitle}</span>
    )}
  </div>
);
